import { useMemo } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';

import Page from '../../atoms/Page';
import AnimalGroupHeader from '../../molecules/AnimalGroupHeader';
import ConsumptionDisplay from '../../organisms/ConsumptionDisplay';

import './BarnConsumptionTab.scss';

function BarnConsumptionTab({
  loading = false,
  titleSegments = [],
  barnId = '',
  orgId = null,
  openFaultIds = [],
  visibleFeedLineIds = [],
  dateRangeOverride = null,
  animalGroupId = null,
  setAnimalGroupId = undefined,
}) {
  const pageTitleSegments = useMemo(() => ['Consumption', ...titleSegments], []);
  let [searchParams] = useSearchParams();
  let searchParamDateRange = null;
  if (searchParams.get('from') && searchParams.get('to')) {
    searchParamDateRange = {
      from: dayjs.tz(searchParams.get('from') * 1000),
      to: dayjs.tz(searchParams.get('to') * 1000),
    };
  }

  return (
    <Page className="BarnConsumptionTab" titleSegments={pageTitleSegments}>
      <AnimalGroupHeader
        loading={loading}
        barnId={barnId}
        orgId={orgId}
        animalGroupId={animalGroupId}
        setAnimalGroupId={setAnimalGroupId}
      >
        {(dateRange) => (
          <ConsumptionDisplay
            barnId={barnId}
            animalGroupDateRange={searchParamDateRange || dateRangeOverride || dateRange}
            openFaultIds={openFaultIds}
            visibleFeedLineIds={visibleFeedLineIds}
          />
        )}
      </AnimalGroupHeader>
    </Page>
  );
}

BarnConsumptionTab.propTypes = {
  loading: PropTypes.bool,
  titleSegments: PropTypes.arrayOf(PropTypes.string),
  barnId: PropTypes.string,
  orgId: PropTypes.string,
  openFaultIds: PropTypes.arrayOf(PropTypes.string),
  visibleFeedLineIds: PropTypes.arrayOf(PropTypes.string),
  dateRangeOverride: PropTypes.shape({
    from: PropTypes.instanceOf(dayjs).isRequired,
    to: PropTypes.instanceOf(dayjs).isRequired,
  }),
  animalGroupId: PropTypes.string,
  setAnimalGroupId: PropTypes.func,
};

export default BarnConsumptionTab;
